import { useState, useCallback } from 'react';
import { accountService } from '@/features/card/services/accountService/accountService';
import { ApproveAccountRequest } from '@/features/card/types/account.types';
import { useSpinner } from '@chikara/ui';
import { t } from '@/i18n';

export const useApproveAccount = () => {
    const { show, hide, isSpinnerLoading } = useSpinner();
    const [error, setError] = useState<string | null>(null);

    const approveAccount = useCallback(async (payload: ApproveAccountRequest): Promise<boolean> => {
        show();
        setError(null);
        try {
            await accountService.approveAccount(payload);
            return true;
        } catch (err) {
            setError(t('dashboard.card.detail.modals.approveCard.errors.generic'));
            return false;
        } finally {
            hide();
        }
    }, [show, hide]);

    return {
        approveAccount,
        isLoading: isSpinnerLoading,
        error
    };
};
